var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHighlight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.84 14c-.37 0-.687-.129-.948-.386a1.257 1.257 0 0 1-.392-.93c0-.362.131-.671.394-.927s.58-.384.95-.384h10.14c.37 0 .686.128.947.384.261.256.392.565.392.928 0 .362-.131.672-.394.93-.262.256-.58.385-.95.385H1.84zM8.65 6.348 7.004 4.735 4.61 7.077 6.247 8.69l2.404-2.342zm-.607-2.62L9.679 5.33l2.346-2.281-1.647-1.617-2.334 2.296zm-1.538-.51 3.7 3.617-2.923 2.873c-.287.281-.63.422-1.028.422s-.741-.14-1.028-.422l-.061.048a1.584 1.584 0 0 1-.448.266 1.396 1.396 0 0 1-.511.096H2.439c-.168 0-.284-.072-.35-.217-.064-.144-.037-.275.082-.392l1.44-1.394-.003-.004a1.417 1.417 0 0 1-.447-1.017 1.332 1.332 0 0 1 .422-1.016l2.923-2.86zm0 0L9.354.428C9.646.143 9.989 0 10.384 0c.394 0 .738.143 1.03.43l1.648 1.604c.292.286.438.622.438 1.009 0 .386-.146.722-.438 1.008l-2.857 2.784-3.7-3.618z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighlight);
export default __webpack_public_path__ + "static/media/highlight.5011516cc09a1feb926efed9de0a26c3.svg";
export { ForwardRef as ReactComponent };